// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"ea68a524","703":"6207f5fd","787":"40d8deb6"}[chunkId] + ".chunk.js";
};